enum MUTATIONS {
	SET_EDITOR_SECTIONS = "setEditorSections",
	SET_CURRENT_SECTION = "setCurrentSection",
	SET_MESSAGE = "setMessage",
	SET_EDITOR_DIRTY = "setEditorDirty",
	SET_LANGUAGES = "setLanguages",
	SET_LANGUAGE = "setLanguage",
	SET_ASSESSMENT_CONTEXT = "setAssessmentContext",
	SET_ASSESSMENT_TYPES = "setAssessmentTypes",
	SET_PREVIEW_HTML = "setPreviewHtml",
	SET_SECTION_ID = "setSectionId",
	SET_SECTION_NAME = "setSectionName",
	SET_SHOW_CONFIMRATION_MODAL = "setShowConfimrationModal",
	SET_STATUS_CONFIRMATION_MODAL = "setStatusConfirmationModal",
	SET_ADD_REPORT_FORM_STATE = "setAddReportFormState",
	SET_EDITED_LANGUAGE = "setEditedLanguage",
	SET_PREVIEW_ERRORS = "setPreviewErrors",
	SET_SECTION = "setSection"
}

export default MUTATIONS;
